import { QuestionnaireHistory } from "../constants/questionnaireHistoryConstants";
export var getQuestionnaireHistory = function (username) {
    return {
        type: QuestionnaireHistory.HISTORY,
        username: username,
    };
};
export var getQuestionnaireOneHistory = function (username) {
    return {
        type: QuestionnaireHistory.RESPONSE_HISTORY_1,
        username: username,
    };
};
export var getQuestionnaireTwoHistory = function (username) {
    return {
        type: QuestionnaireHistory.RESPONSE_HISTORY_2,
        username: username,
    };
};
export var getQuestionnaireMilestoneHistory = function (username) {
    return {
        type: QuestionnaireHistory.RESPONSE_HISTORY_MILESTONE,
        username: username,
    };
};
export var getPersonalWellbeingHistory = function (username) {
    return {
        type: QuestionnaireHistory.PERSONAL_WELLBEING_HISTORY,
        username: username,
    };
};
